export default "public/ideagen_compliSpace_vertical.svg";